import React from 'react';
import HeaderDashboard from '../Components/HeaderDashboard'

const ChangePassword = () => (
    <>
        <HeaderDashboard></HeaderDashboard>
        <div className="toolbar py-2" id="kt_toolbar">
            <div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
                <div className="flex-grow-1 flex-shrink-0 me-5">
                    <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                        <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">Change Password</h1>
                        <span className="h-20px border-gray-200 border-start mx-3"></span>
                        <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                            <li className="breadcrumb-item">
                                <a href="/Settings/UserAdmin" className="text-muted text-hover-primary">Change Password</a>
                            </li>

                        </ul>
                    </div>
                </div>

            </div>
        </div>

        <section className='wraper'>
            <div className='box_shadow mt-14'>
                <div className='row'>
                    <div className='col-md-12'>
                        <h3 className='headings'>Change Password</h3>
                    </div>                 

                </div>
                <div className='col-md-4 mt-3'>
                    <div className='form_control'>
                        <label>Enter Old Password</label>
                        <input type='text' className='form-control' placeholder='Enter Old Password' />
                    </div>
                </div>
                <div className='col-md-4 mt-3'>
                    <div className='form_control'>
                        <label>Enter New Password</label>
                        <input type='text' className='form-control' placeholder='Enter New Password' />
                    </div>
                </div>
                <div className='col-md-4 mt-3'>
                    <div className='form_control'>
                        <label>Confirm New password</label>
                        <input type='text' className='form-control' placeholder='Confirm New password' />
                    </div>
                </div>
                <div className='col-md-4 mt-3'>
                   <button class="btn btn-primary FormNewPassword">Change password </button>
                </div>
            </div>
           


        </section>

    </>
);

export default ChangePassword;